import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLogoBooleanTheme } from '../utils/themeUtils';
import UsersSection from '../components/UsersSection';
import PartnersSection from '../components/PartnersSection';
import BoldTrailTeamConnection from '../components/BoldTrailTeamConnection';
import AdminEmailUsers from '../components/AdminEmailUsers';
import { useAuth } from '../context/AuthContext';

export default function Admin() {
  const navigate = useNavigate();
  // Dark theme for admin (black background)
  const isDarkTheme = true;
  const logoSrc = getLogoBooleanTheme(isDarkTheme);
  const [tab, setTab] = useState('users');
  const { userRole } = useAuth();
  if (userRole !== 'Admin') return null;

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button onClick={() => navigate('/dashboard')} style={styles.logoButton}>
          <img src={logoSrc} alt="RESIDENCE | eXp Realty" style={styles.logo} />
        </button>
        <h1 style={styles.headerTitle}>{tab === 'users' ? 'User Management' : tab === 'boldtrail' ? 'BoldTrail Team Connection' : tab === 'email' ? 'Email Users' : 'Partner Management'}</h1>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
          {[['users', 'Users'], ['partners', 'Partners'], ['boldtrail', 'BoldTrail'], ['email', 'Email users']].map(([key, text]) => (
            <button
              key={key}
              type="button"
              onClick={() => setTab(key)}
              style={{
                padding: '8px 16px',
                borderRadius: '4px',
                border: '1px solid #D4AF37',
                background: tab === key ? '#D4AF37' : 'transparent',
                color: tab === key ? '#000000' : '#D4AF37',
                fontWeight: 600,
                fontSize: '13px',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                cursor: 'pointer',
              }}
            >
              {text}
            </button>
          ))}
        </div>
      </div>

      {tab === 'email' ? (
        <div style={{ padding: '24px 16px', maxWidth: 800 }}>
          <AdminEmailUsers />
        </div>
      ) : tab === 'boldtrail' ? (
        <div style={{ padding: '40px', maxWidth: 720 }}>
          <BoldTrailTeamConnection />
        </div>
      ) : tab === 'partners' ? (
        <div style={{ padding: '40px' }}>
          <PartnersSection />
        </div>
      ) : (
        <div style={{ padding: '40px' }}>
          <UsersSection />
        </div>
      )}
    </div>
  );
}

const FONT = 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
const styles = {
  container: { minHeight: '100vh', backgroundColor: '#000000', color: '#FFFFFF', fontFamily: FONT },
  header: { backgroundColor: '#1a1a1a', borderBottom: '2px solid #D4AF37', padding: '20px 40px', display: 'flex', alignItems: 'center', gap: '20px' },
  logoButton: { backgroundColor: 'transparent', border: 'none', cursor: 'pointer', padding: '0', display: 'flex', alignItems: 'center' },
  logo: { height: '40px', width: 'auto', maxWidth: '150px' },
  headerTitle: { fontSize: '24px', fontWeight: 'bold', margin: '0', letterSpacing: '2px', fontFamily: FONT },
  mainContent: { padding: '40px', display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 300px', gap: '40px', alignItems: 'start' },
  infoBox: { backgroundColor: '#1a1a1a', border: '1px solid #333333', borderRadius: '8px', padding: '24px', height: 'fit-content' },
  infoTitle: { fontSize: '16px', fontWeight: '600', margin: '0 0 16px 0', color: '#D4AF37', fontFamily: FONT },
  roleList: { listStyle: 'none', padding: '0', margin: '0 0 16px 0' },
  roleItem: { fontSize: '13px', color: '#999999', padding: '6px 0', borderBottom: '1px solid #333333', fontFamily: FONT },
  infoText: { fontSize: '12px', color: '#666666', margin: '0', fontFamily: FONT },
};
